import { connect } from 'react-redux';

import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getKnmErknmPositionsSelectOptions } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { getDecisionPositionsSelectOptions } from 'DecisionPackage/MainModule/selectors/decisionSelectors';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';
import { IDictionaryParticipantPositionSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryParticipantPositionSelectOption';
import { IDictionaryPositionSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryPositionSelectOption';
import { Hint } from 'CorePackage/MainModule/components/Hint';

import styles from './ResultDecisionsItemContentSignInfo.module.scss';
import { IKnmFormRef } from '../../../../../../KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IDecisionFormRef } from '../../../../../../DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { lodashGet } from '../../../../../../functions/lodashGet';
import { ProfKindCodesEnum } from '../../../../../../APIPackage/DictionariesModule/enums/ProfKindCodesEnum';
import { ExternalSystemSignInfoBlock } from '../../../../../../CorePackage/MainModule/components/ExternalSystemSignInfoBlock';

interface IResultDecisionsItemContentSignInfoProps {
  fioSignerFieldName: string;
  titleSignerFieldName: string;
  fioSignerId: string;
  titleSignerId: string;
  isDisabledField: boolean;
  isDecision?: boolean;
  isKnm?: boolean;
  isPm?: boolean;
  name: string;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
}

interface IResultDecisionsItemContentSignInfoStoreProps {
  positionsSelectOptions: IDictionaryPositionSelectOption[] | IDictionaryParticipantPositionSelectOption[] | undefined;
  decisionPositionsSelectOptions:
    | IDictionaryPositionSelectOption[]
    | IDictionaryParticipantPositionSelectOption[]
    | undefined;
}

const ResultDecisionsItemContentSignInfoWithoutStore = ({
  isDisabledField,
  positionsSelectOptions,
  fioSignerFieldName,
  titleSignerFieldName,
  fioSignerId,
  titleSignerId,
  decisionPositionsSelectOptions,
  isDecision,
  isKnm,
  isPm,
  name,
  formRef,
}: IResultDecisionsItemContentSignInfoProps & IResultDecisionsItemContentSignInfoStoreProps) => {
  // @ts-ignore
  const formValues = formRef?.current.getState().values;
  const decisionMeta = lodashGet(formValues, name, {});
  // @ts-ignore
  const isTypePP = isPm ? formRef?.current.getFieldState('pmType')?.value?.code === ProfKindCodesEnum.PP : false;

  let content;

  if (
    ((isKnm || isDecision) && decisionMeta?.systemSignatureUsed) ||
    (isPm && isTypePP && decisionMeta?.systemSignatureUsed)
  ) {
    content = (
      <ExternalSystemSignInfoBlock
        systemSignatureDateTime={decisionMeta.systemSignatureDateTime}
        systemSignatureTitle={decisionMeta.systemSignatureTitle}
      />
    );
  } else {
    content = (
      <>
        <FieldBlock
          label={getTitleFieldWithRedStar({
            label: 'ФИО подписавшего решение',
            field: fioSignerFieldName,
            isDecision,
            isKnm,
            isPm,
          })}
          color="black"
          className={styles.FieldBlock}
          placementLabel="left"
          margin="bottom"
          id={fioSignerId}
        >
          <TextInputField name={fioSignerFieldName} disabled={isDisabledField} />
        </FieldBlock>
        <FieldBlock
          label={getTitleFieldWithRedStar({
            label: 'Должность лица, подписавшего решение',
            field: titleSignerFieldName,
            isDecision,
            isKnm,
            isPm,
          })}
          color="black"
          className={styles.FieldBlock}
          placementLabel="left"
          id={titleSignerId}
          margin="bottom"
        >
          <SelectInputField
            name={titleSignerFieldName}
            placeholder="Выберите должность"
            options={isDecision ? decisionPositionsSelectOptions : positionsSelectOptions}
            isSearchable
            disabled={isDisabledField}
            size="medium"
          />
        </FieldBlock>
        <Hint text="Введите ФИО и должность лица, уполномоченного на принятие решения" />
      </>
    );
  }

  return <FieldBlock label={`Подпись предписания`}>{content}</FieldBlock>;
};

const mapStateToProps = (state: IRootState): IResultDecisionsItemContentSignInfoStoreProps => ({
  positionsSelectOptions: getKnmErknmPositionsSelectOptions(state),
  decisionPositionsSelectOptions: getDecisionPositionsSelectOptions(state),
});

export const ResultDecisionsItemContentSignInfo = connect(mapStateToProps)(
  ResultDecisionsItemContentSignInfoWithoutStore,
);
